var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18C21.75 18.1989 21.671 18.3897 21.5303 18.5303C21.3897 18.671 21.1989 18.75 21 18.75H15.0881C14.8094 18.7509 14.5361 18.6737 14.299 18.5273C14.0619 18.3808 13.8705 18.1709 13.7466 17.9213L8.91187 8.25001H3C2.80109 8.25001 2.61032 8.17099 2.46967 8.03034C2.32902 7.88969 2.25 7.69892 2.25 7.50001C2.25 7.3011 2.32902 7.11033 2.46967 6.96968C2.61032 6.82903 2.80109 6.75001 3 6.75001H8.91187C9.19057 6.74912 9.46394 6.82627 9.70104 6.97274C9.93814 7.11921 10.1295 7.32914 10.2534 7.57876L15.0881 17.25H21C21.1989 17.25 21.3897 17.329 21.5303 17.4697C21.671 17.6103 21.75 17.8011 21.75 18ZM14.25 8.25001H21C21.1989 8.25001 21.3897 8.17099 21.5303 8.03034C21.671 7.88969 21.75 7.69892 21.75 7.50001C21.75 7.3011 21.671 7.11033 21.5303 6.96968C21.3897 6.82903 21.1989 6.75001 21 6.75001H14.25C14.0511 6.75001 13.8603 6.82903 13.7197 6.96968C13.579 7.11033 13.5 7.3011 13.5 7.50001C13.5 7.69892 13.579 7.88969 13.7197 8.03034C13.8603 8.17099 14.0511 8.25001 14.25 8.25001Z",
    fill: "#8C9FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhOption);
export default __webpack_public_path__ + "static/media/ph_option.e054ab907067ffe833604c3e466bf97a.svg";
export { ForwardRef as ReactComponent };